<template>
  <article class="registration-success">
    <h1 class="registration-success__title">
      Parabéns, você já pode utilizar o nosso sistema.
    </h1>

    <h3>
      <router-link to="/doctor" class="btn btn-blue">
        Começar agora
      </router-link>
    </h3>
  </article>
</template>

<script>
export default {
  mounted () {
    this.fn_HIDE_PROGRESS()
  }
}
</script>
